// @ts-nocheck
import { Component } from "@theme/component";

class CountdownComponent extends Component {
  connectedCallback() {
    super.connectedCallback();

    this.daysEl = this.querySelector("[data-cd-days]");
    this.hoursEl = this.querySelector("[data-cd-hours]");
    this.minutesEl = this.querySelector("[data-cd-minutes]");
    this.secondsEl = this.querySelector("[data-cd-seconds]");

    this.date = this.dataset.date;
    this.time = this.dataset.time;
    this.timezone = this.dataset.timezone;

    this.targetDate = this.buildTargetDate();
    this.start();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    clearInterval(this.interval);
  }

  buildTargetDate() {
    const [year, month, day] = this.date.split("-").map(Number);
    const [hour, minute] = this.time.split(":").map(Number);

    if (this.timezone.startsWith("UTC")) {
      const offset = Number(this.timezone.replace("UTC", ""));
      return new Date(Date.UTC(year, month - 1, day, hour - offset, minute));
    }
  }

  start() {
    this.update();
    this.interval = setInterval(() => this.update(), 1000);
  }

  update() {
    const now = new Date();
    const diff = this.targetDate - now;

    if (diff <= 0) {
      this.render(0, 0, 0, 0);
      clearInterval(this.interval);
      return;
    }

    const totalSeconds = Math.floor(diff / 1000);

    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    this.render(days, hours, minutes, seconds);
  }

  render(d, h, m, s) {
    if (this.daysEl) this.daysEl.textContent = String(d).padStart(2, "0");
    if (this.hoursEl) this.hoursEl.textContent = String(h).padStart(2, "0");
    if (this.minutesEl) this.minutesEl.textContent = String(m).padStart(2, "0");
    if (this.secondsEl) this.secondsEl.textContent = String(s).padStart(2, "0");
  }
}

if (!customElements.get("countdown-component")) {
  customElements.define("countdown-component", CountdownComponent);
}
